import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

// sections
import { AppWidgetSummary } from "../sections/@dashboard/app";
import {
  Container,
  Typography,
  Box,
  FormControlLabel,
  Switch,
  Grid,
  CircularProgress,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
// ----------------------------------------------------------------------

export default function DashboardPage() {
  const [scoringStats, setScoringStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [allowPicksFrom, setAllowPicksFrom] = useState(moment());
  const [allowPicksUntil, setAllowPicksUntil] = useState(moment());

  const handleAllowPicksFromChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      allow_picks_from: newValue,
    }));
    setAllowPicksFrom(newValue);
  };
  const handleAllowPicksUntilChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      allow_picks_until: newValue,
    }));
    setAllowPicksUntil(newValue);
  };
  useEffect(() => {
    const getData = async () => {
      setLoading(true);

      const resScore = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/scoring/stats`
      );
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/game`);
      setScoringStats(resScore.data);
      setFormData({
        tiebreaker: +res.data.game.tiebreaker,
        allow_picks_until: res.data.game.allow_picks_until,
        allow_picks_from: res.data.game.allow_picks_from,
        scoring: !!resScore.data.scoringEnabled,
      });
      setAllowPicksFrom(res.data.game.allow_picks_from);
      setAllowPicksUntil(res.data.game.allow_picks_until);

      setLoading(false);
    };
    getData();
  }, []);
  const handleSaveForm = () => {
    setLoading(true);
    console.log("formData", formData);
    const saveData = async () => {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/tiebreaker`,
        {
          value: formData.tiebreaker,
        }
      );

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/allow-picks-from`,
        {
          value: formData.allow_picks_from,
        }
      );

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/allow-picks-until`,
        {
          value: formData.allow_picks_until,
        }
      );

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/scoring`, {
        enable: formData.scoring,
      });

      window.location.reload(false);
    };
    saveData();
  };

  return (
    <>
      <Helmet>
        <title> Scoring Entries </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Scoring Entries
        </Typography>
        {scoringStats === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Grid container spacing={4}>
              <Grid item xs={2}>
                <Box sx={{ p: 2 }}>
                  {formData?.scoring !== null && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData?.scoring}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              scoring: e.target.checked,
                            });
                          }}
                        />
                      }
                      label="Run Scoring"
                    />
                  )}
                </Box>
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="Allow Picks From"
                    value={allowPicksFrom}
                    onChange={handleAllowPicksFromChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="Allow Picks Until"
                    value={allowPicksUntil}
                    onChange={handleAllowPicksUntilChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2}>
                <Box sx={{ p: 2 }}>
                  {formData?.tiebreaker !== null && (
                    <Box sx={{ display: "flex", gap: "5px" }}>
                      <TextField
                        id="outlined-basic"
                        label="Tiebreaker"
                        type="number"
                        variant="outlined"
                        value={formData?.tiebreaker}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            tiebreaker: e.target.value,
                          });
                        }}
                      />
                      <Button variant="contained" onClick={handleSaveForm}>
                        Save
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="All Entries"
                  total={scoringStats.allEntriesCount}
                  icon={"eva:list-outline"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="In Progress"
                  total={scoringStats.inProgressCount}
                  color="info"
                  icon={"eva:sync-outline"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="Scored Entries"
                  total={scoringStats.finishedCount}
                  color="warning"
                  icon={"eva:lock-outline"}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </>
  );
}
